<template>
  <div class="footer">
    <GoTop/>
    <div class="line"></div>
    <div class="con">
      <img src="@/assets/img/gbh_logo.jpg" alt="" class="logo" />
      <div class="tit">{{ $t('mobileFooter.contactUs') }}</div>
      <div class="txt address">{{ $t('mobileFooter.address') }}</div>
      <div class="txt phone">{{ $t('mobileFooter.phone') }}</div>
      <div class="txt tel">{{ $t('mobileFooter.fax') }}</div>
      <div class="txt email">{{ $t('mobileFooter.email', { email: 'service@genebiohealth.com' }) }}</div>
      <img src="@/assets/img/m_code.png" alt="" class="code">
      <div class="txt last">{{ $t('mobileFooter.copyright') }}</div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="less" scoped>
.footer {
  width: 100%;
  height: 640px;
  background-color: #fff;
  .line {
    width: 100vw;
    height: 8px;
    background: linear-gradient(to right, #00a0e9, #fff100);
  }
  .con {
    padding-left: 60px;
    padding-top: 62px;
    .logo {
      width: 262px;
      height: 104px;
      margin-bottom: 34px;
    }
    .tit{
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #666666;
        margin-bottom: 30px;
    }
    .txt{
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        margin: 30px 0;
    }
    .code{
        width: 358px;
        height: 105px;
    }
  }
}
</style>
